import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "api/baseurl";
 import jsPDF from "jspdf";
import html2canvas from "html2canvas";
 import MDTypography from "components/MDTypography";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from '@mui/icons-material/Download';
import { Checkbox,} from '@mui/material';

import {
  Box,
  Grid,
  Card,
  Typography,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";

import { keyframes } from "@mui/system";
import { Button } from "@mui/material";
import AddPatientDocuments from "./AddPatientDocuments";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";
import MDButton from "components/MDButton";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddPrescription from "./Addprescription";
import defaultprofileimage from "../images/defaultprofile.jpg";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function PatientDashboard() {
  // const { id } = useParams();
const [userid, setUserid] = useState(null);

useEffect(() => {
  const data = JSON.parse(localStorage.getItem("loginData"));
  if (data?.userid) {
    setUserid(data.userid);
  }
}, []);

  console.log("userid:", userid);

  const [loading, setLoading] = useState(true);
   
  const [coordinator, setCoordinator] = useState(null);
    const [prescription, setPrescription] = useState(null);
        const [devicedata, setDevicedata] = useState(null);

const [selectedNotes, setSelectedNotes] = useState([]);
const handleSelectNote = (id) => {
  setSelectedNotes((prev) =>
    prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
  );
};
  const [tab, setTab] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [opencertificateModal, setOpenCertificateModal] = useState(false);
    const [openprescriptionModal, setOpenPrescriptionModal] = useState(false);
const [currentPage, setCurrentPage] = useState(0);
const [currentPage1, setCurrentPage1] = useState(0);
const [secretKey, setSecretKey] = useState(null);

const [currentNotePage, setCurrentNotePage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
const [totalPages1, setTotalPages1] = useState(0);

const [totalNotePages, setNoteTotalPages] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModal1, setDeleteModal1] = useState(false);
 
  const [progressNote, setProgressNote] = useState(null);
  const [mappingList, setMappingList] = useState([]);
  const [MyDevice, setMydevices] = useState([]);
useEffect(() => {
  const initSecretKey = async () => {
    try {
      const key = await fetchSecretKey();
      if (key) {
        setSecretKey(key);
      }
    } catch (err) {
      console.error("Secret key init failed:", err);
    }
  };

  initSecretKey();
}, []);

  const fetchCoordinator = async () => {
    try {
    if (!secretKey || !userid) return;
     

      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
            if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/user/profile/details/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        console.log(response.data);
        setCoordinator(decrypted ||null);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    } finally {
      setLoading(false);
    }
  };


const doctors = coordinator?.doctor ? [coordinator.doctor] : [];

  
  const fetchDeviceData = async (pageNumber = 1) => {
    try {
    if (!secretKey || !userid) return;
      
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      const response = await axios.get(`/api/devicedata/userid=${userid}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setDevicedata(decrypted.content || []);
         setCurrentPage1(decrypted.number + 1);
          setTotalPages1(decrypted.totalPages);
      }
    } catch (err) {
      console.error("Error fetching coordinator:", err);
    }
  };

    const fetchMapping = async (pageNumber = 1) => {
    try {
    if (!secretKey || !userid) return;
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/patientdoctormapping/mappings`, {
        // params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
      
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData || []);
        //  setCurrentPage(decryptedData.number + 1);
        //   setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } 
  };
    

    const fetchMydevices = async (pageNumber = 1) => {
    try {
    if (!secretKey || !userid) return;
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/devicedata/patient/devices/byuser=${userid}`, {
                params: { page: Math.max(0, pageNumber - 1) },    

          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
      
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMydevices(decryptedData || "");
        //  setCurrentPage(decryptedData.number + 1);
        //   setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } 
  };

useEffect(() => {
  if (!userid || !secretKey) return;

  const loadAllData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        fetchCoordinator(),
        fetchDeviceData(1),
        fetchMapping(1),
        fetchMydevices(1),
      ]);
    } catch (err) {
      console.error("Load error:", err);
    } finally {
      setLoading(false);
    }
  };

  loadAllData();
}, [userid, secretKey]);



  
   const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
   const handlePageChange1= (_, pageNumber) => {
    setCurrentPage1(pageNumber);
  };
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#2e7faeff",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }

  const HandleCertificateModal = (id) => {
  setSelectedId(id);
  setOpenCertificateModal(true);
};
const handleClosecerrificateModal = () => {
  setOpenCertificateModal(false);
  setSelectedId(null);
};
  const HandleCertificateModal1 = (id) => {
  setSelectedId(id);
  setOpenPrescriptionModal(true);
};
const handleClosecerrificateModal1 = () => {
  setOpenPrescriptionModal(false);
  setSelectedId(null);
  // fetchprescription(currentPage);
  
};

 const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };

const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/patientdocuments/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Patient Documents deleted successfully!");
    
          setDeleteModal(false); 
          fetchCoordinator();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Doctor Documents.");
      } finally {
        setLoading(false);
      }
    };

     const handleOpenDeleteModal1 = (id) => {
      setSelectedId(id);
      setDeleteModal1(true);
    };
   


// const handleDownloadSelected = async (noteIds) => {
const handleDownloadSelected = async (selectedNoteIds) => {
  if (!selectedNoteIds?.length || !progressNote?.content) return;

  // Map IDs to full note objects
  const notesToDownload = progressNote.content.filter(doc =>
    selectedNoteIds.includes(doc.id)
  );

  if (!notesToDownload.length) return;

  try {
    const doc = new jsPDF('p', 'mm', 'a4');
    const container = document.createElement('div');
    container.style.width = "210mm";
    container.style.padding = "15px";
    container.style.background = "#fff";
    container.style.color = "#000";
    container.style.fontFamily = "Times New Roman, serif";
    container.style.position = "fixed";
    container.style.left = "-9999px";
    document.body.appendChild(container);

    // ===== HEADER =====
    const headerDiv = document.createElement('div');
    headerDiv.style.display = "flex";
    headerDiv.style.alignItems = "flex-start";
    headerDiv.style.marginBottom = "20px";

    const img = document.createElement('img');
    img.src = coordinator?.image
      ? `data:image/jpeg;base64,${coordinator.image}`
      : defaultprofileimage;
    img.style.width = "150px";
    img.style.height = "150px";
    img.style.borderRadius = "50%";
    img.style.marginRight = "30px";
    headerDiv.appendChild(img);

    const middleDiv = document.createElement('div');
    middleDiv.style.flex = "2";
    middleDiv.style.lineHeight = "1.8";
    middleDiv.style.display = "flex";
    middleDiv.style.flexDirection = "column";
    middleDiv.innerHTML = `
      <span style="font-size:28px; font-weight:bold">${coordinator.firstname} ${coordinator.lastname}</span>
      <span style="font-size:18px;">Email: ${coordinator.email || "N/A"}</span>
      <span style="font-size:18px;">Phone: ${coordinator.phoneNumber || "N/A"}</span>
      <span style="font-size:18px;">Emergency: ${coordinator.emergencyPhoneNumber || "N/A"}</span>
      <span style="font-size:18px;">Doctor Type: ${coordinator.doctorType || "N/A"}</span>
      <span style="font-size:18px;">Address: ${[coordinator.address, coordinator.address1, coordinator.city, coordinator.state, coordinator.country].filter(Boolean).join(", ")} ${coordinator.pin ? `- ${coordinator.pin}` : ""}</span>
    `;
    headerDiv.appendChild(middleDiv);

    const rightDiv = document.createElement('div');
    rightDiv.style.flex = "1";
    rightDiv.style.lineHeight = "1.8";
    rightDiv.style.display = "flex";
    rightDiv.style.flexDirection = "column";
    rightDiv.innerHTML = `
      <span style="font-size:18px;">Age: ${coordinator.age || "N/A"}</span>
      <span style="font-size:18px;">DOB: ${coordinator.dob || "N/A"}</span>
      <span style="font-size:18px;">Gender: ${coordinator.gender || "N/A"}</span>
      <span style="font-size:18px;">Marital Status: ${coordinator.martialStatus || "N/A"}</span>
    `;
    headerDiv.appendChild(rightDiv);

    container.appendChild(headerDiv);

    const hr = document.createElement('hr');
    hr.style.border = "1px solid #000";
    hr.style.margin = "20px 0";
    container.appendChild(hr);

    // ===== Add selected progress notes one below the other =====
    notesToDownload.forEach((note) => {
      const noteDiv = document.createElement('div');
      noteDiv.style.fontSize = "18px";
      noteDiv.style.marginBottom = "20px";
      noteDiv.innerHTML = `
        <strong>Progress Note (Version ${note.version || "N/A"}):</strong><br/>
        ${note.notes || "No notes available"}<br/>
        <small>Date & Time: ${note.createdTime ? formatISTDateTimePretty(note.createdTime) : "N/A"}</small>
      `;
      container.appendChild(noteDiv);
    });

    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdfWidth = 190;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    doc.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
    doc.save(`${coordinator.firstname}_${coordinator.lastname}_ProgressNotes.pdf`);

    document.body.removeChild(container);
  } catch (err) {
    console.error("PDF download error:", err);
    alert("Failed to generate PDF. Check console for details.");
  }
};




const handleDownloadPDF = async (selectedNote) => {
  try {
    const doc = new jsPDF('p', 'mm', 'a4');

    const container = document.createElement('div');
    container.style.width = "210mm";
    container.style.padding = "15px";
    container.style.background = "#fff";
    container.style.color = "#000";
    container.style.fontFamily = "Times New Roman, serif";
    container.style.position = "fixed";
    container.style.left = "-9999px";
    document.body.appendChild(container);

    // ===== HEADER =====
    const headerDiv = document.createElement('div');
    headerDiv.style.display = "flex";
    headerDiv.style.alignItems = "flex-start";
    headerDiv.style.marginBottom = "20px";

    // Left: Profile Photo
    const img = document.createElement('img');
    img.src = coordinator?.image ? `data:image/jpeg;base64,${coordinator.image}` : defaultprofileimage;
    img.style.width = "150px"; 
    img.style.height = "150px";
    img.style.borderRadius = "50%";
    img.style.marginRight = "30px";
    headerDiv.appendChild(img);

    // Middle: Name + Contact + Doctor Type + Address
    const middleDiv = document.createElement('div');
    middleDiv.style.flex = "2";
    middleDiv.style.lineHeight = "1.8";
    middleDiv.style.display = "flex";
    middleDiv.style.flexDirection = "column";
    middleDiv.style.justifyContent = "flex-start"; 
    middleDiv.innerHTML = `
      <span style="font-size:28px; font-weight:bold">${coordinator.firstname} ${coordinator.lastname}</span>
      <span style="font-size:18px;">Email: ${coordinator.email || ""}</span>
      <span style="font-size:18px;">Phone: ${coordinator.phonecountrycode || ""} ${coordinator.phoneNumber || ""}</span>
      <span style="font-size:18px;">Emergency: ${coordinator.emergencycountrycode || ""} ${coordinator.emergencyPhoneNumber || ""}</span>
      <span style="font-size:18px;">Doctor Type: ${coordinator.doctorType || ""}</span>
      <span style="font-size:18px;">Address: ${[coordinator.address, coordinator.address1, coordinator.city, coordinator.state, coordinator.country].filter(Boolean).join(", ")} ${coordinator.pin ? `- ${coordinator.pin}` : ""}</span>
    `;
    headerDiv.appendChild(middleDiv);

    // Right: Age, DOB, Gender, Marital Status
    const rightDiv = document.createElement('div');
    rightDiv.style.flex = "1";
    rightDiv.style.lineHeight = "1.8";
    rightDiv.style.display = "flex";
    rightDiv.style.flexDirection = "column";
    rightDiv.style.justifyContent = "flex-start";
    rightDiv.innerHTML = `
      <span style="font-size:18px;">Age: ${coordinator.age || ""}</span>
      <span style="font-size:18px;">DOB: ${coordinator.dob || ""}</span>
      <span style="font-size:18px;">Gender: ${coordinator.gender || ""}</span>
      <span style="font-size:18px;">Marital Status: ${coordinator.martialStatus || ""}</span>
    `;
    headerDiv.appendChild(rightDiv);

    container.appendChild(headerDiv);

    // Horizontal line
    const hr = document.createElement('hr');
    hr.style.border = "1px solid #000";
    hr.style.margin = "20px 0";
    container.appendChild(hr);

    // ===== Selected Progress Note =====
    if (selectedNote) {
      const noteDiv = document.createElement('div');
      noteDiv.style.fontSize = "18px";
      noteDiv.style.marginBottom = "15px";
      noteDiv.innerHTML = `
        <strong>Progress Note (Version ${selectedNote.version}):</strong><br/>
        ${selectedNote.notes}<br/>
        <small>Date & Time: ${formatISTDateTimePretty(selectedNote.createdTime)}</small>
      `;
      container.appendChild(noteDiv);
    } else {
      const noNote = document.createElement('div');
      noNote.style.fontSize = "18px";
      noNote.innerText = "No progress note selected.";
      container.appendChild(noNote);
    }

    // Render PDF
    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdfWidth = 190;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    doc.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
    doc.save(`${coordinator.firstname}_${coordinator.lastname}_ProgressNote.pdf`);

    document.body.removeChild(container);
  } catch (err) {
    console.error("PDF download error:", err);
    alert("Failed to generate PDF. Check console for details.");
  }
};





const handleDelete1 = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post("/api/prescriptiondetails/delete", encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Prescription deleted successfully!");
    
          setDeleteModal1(false); 
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Prescription.");
      } finally {
        setLoading(false);
      }
    };

    const formatISTDateTimePretty = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];

  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // 0 → 12 for 12-hour format

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
};


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
    <Card sx={{ p: 3, mt: 3 }}>
  {coordinator ? (
    <Grid container spacing={3}>
      {/* Left: Profile Image
      <Grid item xs={12} md={3} textAlign="center">
        <img
          src={coordinator.image?`data:image/jpeg;base64,${coordinator.image}` : defaultprofileimage}
          alt={coordinator.imageMeta || "Profile"}
          style={{ width: 150, height: 150, borderRadius: "50%" }}
        />
      </Grid> */}

      {/* Middle: Basic Info */}
      <Grid item xs={12} md={6} ml={3}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
          {coordinator.firstname} {coordinator.lastname}
        </Typography>
{/* <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>NMC Registered Number:</strong> {coordinator.nmcRegisteredNumber}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>year Of Registration:</strong> {coordinator.yearOfRegistration}
        </Typography><Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>verification Status:</strong> {coordinator.verificationstatus}
        </Typography> */}
         <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Email:</strong> {coordinator.email}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Phone Number:</strong> {coordinator.phonecountrycode} {coordinator.phoneNumber}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Emergency Phone Number:</strong> {coordinator.emergencycountrycode} {coordinator.emergencyPhoneNumber}
        </Typography>
       
      <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
  <strong>Address:</strong>{" "}
  {[coordinator.address,coordinator.address1, coordinator.city, coordinator.state, coordinator.country]
    .filter(Boolean)
    .join(", ")}
  {coordinator.pin ? ` - ${coordinator.pin}` : ""}
</Typography>
        
      </Grid>
    
      {/* Right: More Info */}
      <Grid item xs={12} md={3} sx={{ mt: 4.2 }}>
         
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Age:</strong> {coordinator.age}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>Marital Status:</strong> {coordinator.martialStatus}
        </Typography>
        <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
          <strong>DOB:</strong> {coordinator.dob}
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          <strong>Gender:</strong> {coordinator.gender}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <Typography
      sx={{
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        color: "gray",
        my: 2,
      }}
    >
      No Data Available
    </Typography>
  )}

        {/* Tabs Section */}
        <Box sx={{ mt: 4 }}>
        <Tabs
  value={tab}
  onChange={(e, newVal) => setTab(newVal)}
  variant="scrollable"
  scrollButtons="auto"
  TabIndicatorProps={{
    style: {
      backgroundColor: "#1A237E", // elegant blue underline
      height: "3px",
      borderRadius: "2px",
    },
  }}
  sx={{
    backgroundColor: "#fff", // clean white bg
    borderBottom: "1px solid #e0e0e0",
    "& .MuiTab-root": {
      fontWeight: 500,
      fontSize: "16px",
      textTransform: "none",
      color: "#666",
      minHeight: "48px",
      padding: "10px 20px",
      transition: "all 0.3s ease",
    },
    "& .Mui-selected": {
      color: "#1A237E", // professional blue
      fontWeight: 600,
    },
    "& .MuiTab-root:hover": {
      color: "#1A237E",
      backgroundColor: "rgba(25, 118, 210, 0.08)", // light hover
      borderRadius: "6px 6px 0 0",
    },
  }}
>
<Tab label="My Doctor" />

  {/* <Tab label="My Devices" /> */}
  <Tab label="My Readings" />
    
</Tabs>



{tab === 0 && (
 <Box sx={{ mt: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
     
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
             {[ "Name", "Contact",  "Doctor Type", "Address","Hospital Address"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                 color: "#fff",
                fontWeight: "600",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "105px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
  {mappingList?.length > 0 ? (
    mappingList.map((mapping, idx) => (
      <TableRow key={idx}>
       
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {mapping.doctor.firstname} {mapping.doctor.lastname}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
           {mapping.doctor.phoneNumber}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {mapping.doctor.doctorType}
        </TableCell>
         <TableCell 
  sx={{ 
    border: "1px solid #ddd", 
    textAlign: "center", 
    padding: "12px", 
    whiteSpace: "pre-line"  // allows line breaks
  }}
>
  {mapping.doctor.address},<br />
  {mapping.doctor.city}, {mapping.doctor.state},<br />
  {mapping.doctor.country} - {mapping.doctor.pin}
</TableCell> 
<TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
  {mapping.hospitalAddress || "N/A"}
</TableCell>

         
             
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={6}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                  </TableHead>

    </Table>
  </Box>
)}

{tab === 1 && (
 <Box sx={{ mt: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
     
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
             {[ "Device Name", "Device Type"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
               color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  //minWidth: index === 0 ? "315px" : "105px",
//width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
                minWidth:"500px",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
  {MyDevice?.length > 0 ? (
    MyDevice.map((doc, idx) => (
      <TableRow key={idx}>
       
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.devicename || ""}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.devicetype || ""}
        </TableCell>
       
           
          
          
         
             
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={6}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                  </TableHead>

    </Table>
  </Box>
)}


{tab === 2 && (
 <Box sx={{ mt: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
     
    </Box>
    <Table sx={{ border: "1px solid #ddd" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
             {[ "Device Name",  "Data Type", "Datavalue","Recorded At"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
               color: "#fff",
                fontWeight: "600", 
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "12px",
  minWidth: index === 0 ? "315px" : "105px",
width: index === 0 ? "315px" : "400px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      <TableBody>
  {devicedata?.length > 0 ? (
    devicedata.map((doc, idx) => (
      <TableRow key={idx}>
       
       
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.devicename || ""}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.datatype || ""}
        </TableCell>
           <TableCell sx={{ border: "1px solid #ddd", padding: "12px" }}>
         <ul style={{ margin: 0, paddingLeft: "16px" }}>
           {doc?.bpSystolic  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Systolic:</strong>{" "}
                 <span style={{ color: "#2e7fae", fontWeight: 700 }}>
                   {doc?.bpSystolic }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.bpDiastolic  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Diastolic:</strong>{" "}
                 <span style={{ color: "#2e7fae", fontWeight: 700 }}>
                   {doc?.bpDiastolic }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.bpMean  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Mean:</strong>{" "}
                 <span style={{ color: "#2e7fae", fontWeight: 700 }}>
                   {doc?.bpMean }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.randomSugar  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>Random Sugar:</strong>{" "}
                 <span style={{ color: "#2e7fae", fontWeight: 700 }}>
                   {doc?.c }
                 </span>
               </MDTypography>
             </li>
           )}
         </ul>
       </TableCell>
          
          <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.recordedAt || ""}
        </TableCell>
         
             
              </TableRow>
            ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={6}
              align="center"
              sx={{ border: "1px solid #ddd", color: "gray", fontStyle: "italic" }}
            >
              No Data Available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
                  </TableHead>
 <Box mt={2} display="flex" justifyContent="center">
          <Pagination
            count={totalPages1}
            page={currentPage1}
            onChange={handlePageChange1}
            color="success"
             sx={{
    "& .MuiPaginationItem-root": {
      borderRadius: "4px",
      color: "#1A237E",          // Text color
      borderColor: "#1A237E",    // Border color if outlined
    },
    "& .MuiPaginationItem-root.Mui-selected": {
      backgroundColor: "#1A237E", // Selected background
      color: "#fff",                 // Selected text color
    },
    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#1A237E", // Slight hover effect
    },
  }}
          />
        </Box>
    </Table>
  </Box>
)}


        </Box>
      </Card>
        
      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Document</Typography>
                      <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>
                   <Modal open={deleteModal1} onClose={() => setDeleteModal1(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
                      <Typography variant="h6" gutterBottom>Are you sure you want to delete this Prescription</Typography>
                      <MDButton onClick={handleDelete1} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
                      <MDButton color="secondary" onClick={() => setDeleteModal1(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
                    </Card>
                  </Modal>

      {opencertificateModal && (
  <AddPatientDocuments
    isOpen={opencertificateModal}
    onRequestClose={handleClosecerrificateModal}
    id={selectedId}
    fetchCoordinator = {fetchCoordinator}
  />
)}
{/* {openprescriptionModal && (
  <AddPrescription
    isOpen={openprescriptionModal}
    onRequestClose={handleClosecerrificateModal1}
    id={selectedId}
    onAdded={() => fetchprescription(1)}
  />
)} */}
    </DashboardLayout>
  );
}

export default PatientDashboard;
